import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { CommonComponent } from '../../common/common.component';
import { SettingService } from '../../nucleo/configuracion/setting.service';
import { AutenticacionService } from '../../seguridad/autenticacion.service';


import { IModalGenerico } from '../../nucleo/interface/form/IModalGenerico';

import { ServicioService } from '../../servicio/servicio.service';
import { ModalImagenService } from './modal-imagen.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-modal-imagen',
  templateUrl: './modal-imagen.component.html',
  styleUrls: ['./modal-imagen.component.css']
})
export class ModalImagenComponent extends CommonComponent implements OnInit {
  
  public modal: IModalGenerico;
  urlpdf: SafeResourceUrl;
  @ViewChild('pdfview') public pdfview: ElementRef;
  public showModalSpinner : boolean ;
  
  constructor(public service: ServicioService,  
    toastr: ToastrService,
    loginService: AutenticacionService,
    settingService: SettingService,
    public modalImagenService: ModalImagenService) { 
    super(service, toastr, loginService, settingService);
    modalImagenService.registrarComponente(this);
  }

  ngOnInit() {
  }

  descargarDocumento() {  
    this.showModalSpinner = true;
   
    this.service.descargar('archivo', this.modalImagenService.documento).pipe(finalize(()=> this.showModalSpinner = false)).subscribe(response => {
      const fileURL = URL.createObjectURL(response);
      const pdfSrc  = fileURL + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';
      this.pdfview.nativeElement.setAttribute('data', pdfSrc);
      console.log(fileURL);
    },
      err => this.toastr.error(this.settingService.getMensaje('C0062'), 'Error: ', this.setOptionsToat())
    );

    /*this.service.descargar('documento', this.modalImagenService.documento).pipe(finalize(()=> this.showModalSpinner = false)).subscribe(response => {
      const fileURL = URL.createObjectURL(response);
      const pdfSrc  = fileURL + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';
      this.pdfview.nativeElement.setAttribute('data', pdfSrc);
      console.log(fileURL);
    });*/
  }

  cerrarModal(){
    this.modalImagenService.ocultarModal();
    this.modalImagenService.notificacion.emit({notificacion: false});
    
  }


}
